var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "154.000000pt",
    height: "148.000000pt",
    viewBox: "0 0 154.000000 148.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,148.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397 1143 c-13 -12 -7 -41 9 -47 9 -3 39 -6 68 -6 l52 0 54 -202 c29 -112 57 -218 62 -235 l9 -33 214 0 c212 0 244 5 216 33 -8 8 -75 13 -201 15 -108 2 -191 7 -191 13 -6 34 -5 34 181 39 l184 5 48 120 c26 66 47 131 45 145 l-2 25 -275 5 -274 5 -16 50 c-8 28 -19 56 -23 63 -9 13 -148 18 -160 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686 558 c-23 -33 -19 -64 10 -87 32 -25 52 -26 82 -5 28 19 30 74 4 97 -27 25 -78 22 -96 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937 562 c-25 -27 -22 -78 5 -96 12 -9 31 -16 41 -16 24 0 67 44 67 70 0 50 -79 80 -113 42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.dcf3a819cd50d5c9f8ffe5098abc8e4a.svg";
export { ForwardRef as ReactComponent };